import React from 'react';

import AdditionalLinksEdit from './AdditionalLinksEdit';
import EditModalControl from '../../common/edit/EditModalControl';

interface Props {
  type: 'button' | 'link';
  show?: boolean;
  buttonDataTestId?: string;
  linkDataTestId?: string;
  onSuccess: () => void;
}

const AdditionalLinksEditModal = ({ type, show, buttonDataTestId, linkDataTestId, onSuccess }: Props) => {
  return (
    <EditModalControl
      type={type}
      title={'Edit Additional Links'}
      show={show}
      buttonDataTestId={buttonDataTestId}
      linkDataTestId={linkDataTestId}
      onSuccess={onSuccess}
    >
      <AdditionalLinksEdit />
    </EditModalControl>
  );
};

export default AdditionalLinksEditModal;
